import { DateUtil } from '@/utils';
import mutations from './IamViolationMutation';
import actions from './IamViolationAction';
import getters from './IamViolationGetter';

const state = {
  totalCount: -1,
  searchParam: {
    divisionCode: '', // 사업부
    divisions: '',
    cspCode: '', // CSP
    linkedAccountId: '', // Linked Account
    rootAccountId: '',
    projectNm: '', // 프로젝트 명
    totalCnt: -1,
    searchPeriod: {
      startDate: null,
      endDate: null,
    },
  },
  gridData: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/security/violations/IamViolationStore.js